const doc = [({"da":({"js":({"admin":({"logs":({"table":({"name":"Navn", "trackable_type":"Sporbar", "trackable_id":"Sporbar ID", "key":"Nøgle", "system":"System"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;